import { render } from "./CutPaletteCololorCanvasEditView.vue?vue&type=template&id=a8fc34d8&scoped=true&ts=true"
import script from "./CutPaletteCololorCanvasEditView.vue?vue&type=script&lang=ts"
export * from "./CutPaletteCololorCanvasEditView.vue?vue&type=script&lang=ts"

import "./CutPaletteCololorCanvasEditView.vue?vue&type=style&index=0&id=a8fc34d8&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8fc34d8"]])

export default __exports__